"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Confirm = _interopRequireDefault(require("../Confirm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KEY_ESC = 27;

var ModalWindow = /*#__PURE__*/function (_Component) {
  _inherits(ModalWindow, _Component);

  var _super = _createSuper(ModalWindow);

  function ModalWindow() {
    var _this;

    _classCallCheck(this, ModalWindow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: true,
      confirm: {
        isOpen: false,
        coordinates: null
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function (ev) {
      if (ev && ev.stopPropagation) ev.stopPropagation();
      if (_this.props.onClose) _this.props.onClose();

      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModalViaConfirm", function (ev) {
      var confirm = {
        isOpen: true
      };

      if (ev && ev.pageX && ev.pageY) {
        confirm.coordinates = [ev.pageX, ev.pageY];
      }

      return _this.setState({
        confirm: confirm
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideConfirm", function () {
      return _this.setState({
        confirm: {
          isOpen: false,
          coordinates: null
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalClick", function (ev) {
      return ev.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (ev) {
      var isDirty = _this.props.isDirty;

      if (KEY_ESC === ev.keyCode) {
        if (isDirty) return _this.closeModalViaConfirm();
        return _this.handleCloseModal();
      }
    });

    return _this;
  }

  _createClass(ModalWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keyup', this.handleKeyUp, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.modalContainer) {
        document.body.removeChild(this.modalContainer);
      }

      document.removeEventListener('keyup', this.handleKeyUp, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isOpenModal = _this$state.isOpen,
          _this$state$confirm = _this$state.confirm,
          isOpenConfirm = _this$state$confirm.isOpen,
          coordinates = _this$state$confirm.coordinates;
      if (!isOpenModal) return null;

      if (!this.modalContainer) {
        this.modalContainer = document.createElement('div');
        this.modalContainer.classList.add('modal-popup-wrapper');
        document.body.appendChild(this.modalContainer);
      }

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          modalStyles = _this$props.modalStyles,
          withGrid = _this$props.withGrid,
          safetyMode = _this$props.safetyMode,
          isDirty = _this$props.isDirty,
          withForm = _this$props.withForm,
          confirmProps = _this$props.confirmProps;
      var overlayProps = {
        className: (0, _classnames["default"])('modal-window-overlay', _defineProperty({}, className, Boolean(className)))
      };
      var handleCloseModal = isDirty ? this.closeModalViaConfirm : this.handleCloseModal;
      if (!safetyMode) overlayProps.onClick = handleCloseModal;

      var renderer = /*#__PURE__*/_react["default"].createElement("div", _extends({}, overlayProps, {
        key: "modal"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('modal-window', {
          'modal-grid': withGrid
        }),
        style: modalStyles,
        onClick: this.handleModalClick
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "modal-window-close icon-close",
        onClick: handleCloseModal
      }), withForm ? children({
        handleCloseModal: handleCloseModal
      }) : children));

      var Portal = /*#__PURE__*/_reactDom["default"].createPortal(renderer, this.modalContainer);

      if (isOpenConfirm) {
        return [Portal, /*#__PURE__*/_react["default"].createElement(_Confirm["default"], _extends({
          key: "confirm",
          action: this.handleCloseModal,
          cancel: this.hideConfirm,
          modalCors: coordinates
        }, confirmProps))];
      }

      return Portal;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isOpen !== prevState.isOpen) {
        return {
          isOpen: nextProps.isOpen
        };
      }

      return null;
    }
  }]);

  return ModalWindow;
}(_react.Component);

ModalWindow.propTypes = {
  // ownProps
  isOpen: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  modalStyles: _propTypes["default"].object,
  withGrid: _propTypes["default"].bool,
  safetyMode: _propTypes["default"].bool,
  isDirty: _propTypes["default"].bool,
  withForm: _propTypes["default"].bool,
  confirmProps: _propTypes["default"].object
};
ModalWindow.defaultProps = {
  isOpen: true,
  className: null,
  onClose: null,
  modalStyles: null,
  withGrid: false,
  safetyMode: true,
  isDirty: false,
  withForm: false,
  confirmProps: null
};
var _default = ModalWindow;
exports["default"] = _default;